<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="tabela.busca" v-if="!addUser" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">DIVULGADORES</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="tabela.busca" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text @click="criarNovo" tile color="#4A148C">
            <v-icon left dark>add_circle</v-icon>Cadastrar
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon @click="editItem(item)">edit</v-icon>
        <v-icon medium @click="deleteItem(item)">delete</v-icon>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <td>https://aicheckin.com.br/{{companyobj.linkVendas}}?d={{item.id}}</td>
      </template>
      <template v-slot:[`item.ativo`]="{ item }">
        <v-icon v-if="item.ativo == true" color="success">circle</v-icon>
        <v-icon v-else color="error">circle</v-icon>
      </template>
      <template v-slot:[`item.aplicaDesconto`]="{ item }">
        <v-icon v-if="item.ativo " :color="item.aplicaDesconto ? 'success' : 'error'">circle</v-icon>
      </template>
      <template v-slot:[`item.valorDesconto`]="{ item }">
        <td v-if="item.valorDesconto">{{ item.valorDesconto }}%</td>
        <td v-else style="color: #aaa">---</td>
      </template>
      <template v-slot:no-data>
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum divulgador encontrado</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <!-- CARD INSERE USUARIOS -->
    <v-card v-else style="border-radius: 10px;">
      <template v-if="adicionarDivulgador">
        <v-card-title>
          <span class="textoUser">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <p style="font-size:15px; color:#7B1FA2"> *O preenchimento de todos os campos é obrigatório</p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="editedItem.nome" outlined label="Nome" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.cpf" outlined label="CPF" color="#7B1FA2" v-mask="'###.###.###-##'" type="tel"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.email" outlined label="E-mail" color="#7B1FA2"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model="editedItem.celular" outlined label="WhatsApp com DDD" color="#7B1FA2" type="tel" v-mask="'(##) #####-####'"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-switch v-model="editedItem.ativo" label="Ativo" color="#7B1FA2" hide-details></v-switch>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-switch v-model="editedItem.aplicaDesconto" label="Aplica desconto" color="#7B1FA2" hide-details></v-switch>
              </v-col>
              <v-col cols="12" sm="4" md="1" v-if="editedItem.aplicaDesconto">
                <v-text-field v-model="editedItem.valorDesconto" outlined label="Porcentagem" color="#7B1FA2" type="tel" append-icon="mdi-percent"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A148C" class="cssBotao" dark large @click="save">Salvar</v-btn>
          <v-btn color="#BA68C8" max-width="" class="cssBotao" large dark @click="close">Cancelar</v-btn>
        </v-card-actions>
      </template>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import moment from 'moment'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      fullPage: true,
      isLoading: false,
      addUser: false,
      adicionarDivulgador: false,
      temInscritos: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'CPF', value: 'cpf' },
          { text: 'E-mail', value: 'email' },
          { text: 'Link', value: 'id' },
          { text: 'Clicks', value: 'qtdClicks'},
          { text: 'Ativo', value: 'ativo' },
          { text: 'Aplica Desconto', value: 'aplicaDesconto' },
          { text: 'Valor de Desconto', value: 'valorDesconto' },
          { text: 'Ações', value: 'action', align: 'center', sortable: false },
        ],
        conteudo: []
      },
      editedIndex: -1,
      editedItem: {
        nome: '',
        cpf: '',
        email: '',
        celular: '',
        ativo: null,
        empresaId: '',
        aplicaDesconto: false,
        valorDesconto: 0,
      },
      defaultItem: {
        nome: '',
        cpf: '',
        email: '',
        celular: '',
        ativo: null,
        empresaId: '',
        aplicaDesconto: false,
        valorDesconto: 0,
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle() {
        return this.editedIndex === -1 ? 'ADICIONAR NOVO DIVULGADOR ' : 'EDITAR DIVULGADOR'
      }
    }),

    mounted() {
      this.carregaDivulgadores()
    },

    watch: {
      
    },

    methods: {
      async carregaDivulgadores() {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Divulgadores?filter={"where":{"empresaId":"' + this.companyobj.id + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          } else {
            this.isLoading = false
          }
        })
      },

      criarNovo() {
        this.adicionarDivulgador = true
        this.addUser = true
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()
        let comparison = 0;
        if (dataC >= dataA) {
          comparison = 1;
        } else if (dataC < dataA) {
          comparison = -1;
        }
        return comparison;
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.adicionarDivulgador = true
        this.addUser = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o divulgador: ' + item.nome + '?')
        if (r == true) {
          this.isLoading = true
          await axios.delete(`${baseApiUrl}Divulgadores/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          .then(() => {
            this.isLoading = false
            var vm = this
            vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaDivulgadores()
          })
        }
      },

      close() {
        this.addUser = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save() {
        var vm = this;
        if (this.editedIndex != -1) {
          if (this.editedItem.nome || this.editedItem.cpf || this.editedItem.email || this.editedItem.celular || this.editedItem.ativo) {
            if (this.editedItem.aplicaDesconto && !this.editedItem.valorDesconto) {
              vm.$refs.chamaSnackbar.snack("orange", "Para que um desconto seja aplicado, informe um valor", "ATENÇÃO")
              return
            }

            this.isLoading = true
            this.editedItem.valorDesconto = parseFloat(this.editedItem.valorDesconto.toString().replace(',','.'))

            await axios.patch(`${baseApiUrl}Divulgadores/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
                this.carregaDivulgadores()
                this.close()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        } else {
          if (this.editedItem.nome || this.editedItem.cpf || this.editedItem.email || this.editedItem.celular || this.editedItem.ativo) {
            if (this.editedItem.aplicaDesconto && !this.editedItem.valorDesconto) {
              vm.$refs.chamaSnackbar.snack("orange", "Para que um desconto seja aplicado, informe um valor", "ATENÇÃO")
              return
            }

            this.isLoading = true

            this.editedItem.empresaId = this.companyobj.id
            this.editedItem.valorDesconto = parseFloat(this.editedItem.valorDesconto.toString().replace(',','.'))
            await axios.post(`${baseApiUrl}Divulgadores/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, this.editedItem)
            .then(response => {
              if (response.data != null) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Divulgador cadastrado com sucesso!", "INFORMAÇÃO")
                this.carregaDivulgadores()
                this.close()
              }
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao cadastrar divulgador, tente novamente", "ERRO")
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#0288D1", "Preencha todos os campos!", "INFORMAÇÃO")
          }
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>